import {Grey17, Grey6} from "../../theme/styles";

import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography} from "@mui/material";
import {Edit, MoreVert} from "@mui/icons-material";
import css_self from "../Navigation/css/NavBar.module.scss";
import css_button from "../Common/css/CCButton.module.scss";
import React from "react";
import CCButton from "../Common/CCButton";
import ReactJson from "react-json-view";
import {formatLocal} from "../../util/Formatters";
import {withAppContext} from "../../util/withAppContext";

class BillSubscriptionCommunicationTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("bill-subscription-communication-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("bill-subscription-communication-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("bill-subscription-communication-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("bill-subscription-communication-form-applet-save", this.onCancelHandler);
    }

    enterpriseComponentInsertCompleted(ec) {
        super.enterpriseComponentInsertCompleted(ec)

        ec.invalidateChildren();
    }

    enterpriseComponentDeleteCompleted(ec) {
        super.enterpriseComponentDeleteCompleted(ec)

        ec.invalidateChildren();
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }
        return super.getCellRenderer(name);
    };

    onRowDoubleClick(params) {
        this.applet.getEnterpriseComponent().selectRecord(params.row.id);

        this.setState({renderTarget: "Show Communication"});
    };

    handleMenuClick(identifier) {
        super.handleMenuClick(identifier);
    }

    renderJSONDialog() {
        return (
            <Dialog onClose={(event, reason) => this.setState({renderTarget: null})} open={true} scroll="body" maxWidth={"xl"} maxHeight={"xl"}>
                <DialogTitle>Bill.com Message {formatLocal(this.applet.getEnterpriseComponent().getAttributeValue("CreatedDatetime"))}</DialogTitle>
                <DialogActions>
                    <CCButton className={css_button.blueStandardButton} style={{marginRight: "20px"}} color="primary" onClick={() => this.setState({renderTarget: null})}>
                        Close
                    </CCButton>
                </DialogActions>
                <DialogContent>
                    <p style={{fontFamily: "Courier New", fontSize: "12px"}}>
                        <ReactJson keySort={true} src={this.applet.getEnterpriseComponent().getAttributeValue("PayloadJSON")} collapseStringsAfterLength={175} collapsed={10}/>
                    </p>
                </DialogContent>
                <DialogActions>
                    <CCButton className={css_button.blueStandardButton} style={{marginRight: "20px"}} color="primary" onClick={() => this.setState({renderTarget: null})}>
                        Close
                    </CCButton>
                </DialogActions>
            </Dialog>
        )
    }

    renderExtension() {
        if (this.state.renderTarget === "Show Communication") {
            return this.renderJSONDialog()
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderActionCell = (___, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", marginTop: "-4px", backgroundColor: "#FFFFFF", marginLeft: "-10px", marginRight: "-20px", paddingBottom: "5px", paddingLeft: "4px"}}>
                <IconButton onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit Subscription"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Subscription</Typography>
                    </MenuItem>
                </Menu>
            </div>
        )
    }
}

export default withNavigate(withAppContext(withBreakpoint(BillSubscriptionCommunicationTable)));